import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../core/Accessor.js";
import s from "../../core/Handles.js";
import r from "../../core/Logger.js";
import { unwrapOr as i, isNone as a, isSome as u } from "../../core/maybe.js";
import o from "../../core/PerformanceSampler.js";
import n from "../../core/PooledArray.js";
import { isAborted as h, createAbortError as _, when as d } from "../../core/promiseUtils.js";
import { reactTruthy as l } from "../../core/reactiveUtils.js";
import { Milliseconds as c } from "../../core/time.js";
import { init as E } from "../../core/watchUtils.js";
import { property as T } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as m } from "../../core/accessorSupport/decorators/subclass.js";
import { PromiseQueue as g } from "../../layers/support/PromiseQueue.js";
import p from "./debugFlags.js";
var I = r.getLogger("esri.views.support.Scheduler");

function R(e) {
  return new F.Scheduler({
    nowFunc: e
  });
}

var f;
!function (e) {
  e.RESOURCE_CONTROLLER = "schedule", e.SLIDE = "slide", e.STREAM_DATA_LOADER = "stream loader", e.ELEVATION_QUERY = "elevation query", e.TERRAIN_SURFACE = "terrain", e.SURFACE_GEOMETRY_UPDATES = "surface geometry updates", e.GRAPHICS_CORE = "Graphics3D", e.I3S_CONTROLLER = "I3S", e.POINT_CLOUD_LAYER = "point cloud", e.FEATURE_TILE_FETCHER = "feature fetcher", e.OVERLAY = "overlay", e.STAGE = "stage", e.GRAPHICS_DECONFLICTOR = "graphics deconflictor", e.FILTER_VISIBILITY = "Graphics3D filter visibility", e.SCALE_VISIBILITY = "Graphics3D scale visibility", e.FRUSTUM_VISIBILITY = "Graphics3D frustum visibility", e.POINT_OF_INTEREST_FREQUENT = "POI frequent", e.POINT_OF_INTEREST_INFREQUENT = "POI infrequent", e.LABELER = "labeler", e.FEATURE_QUERY_ENGINE = "feature query", e.FEATURE_TILE_TREE = "feature tile tree", e.FEATURE_TILE_TREE_ACTIVE = "fast feature tile tree", e.ELEVATION_ALIGNMENT = "elevation alignment", e.TEXT_TEXTURE_ATLAS = "text texture atlas", e.TEXTURE_UNLOAD = "texture unload", e.LINE_OF_SIGHT_TOOL = "line of sight tool", e.LINE_OF_SIGHT_TOOL_INTERACTIVE = "interactive line of sight tool", e.ELEVATION_PROFILE = "elevation profile", e.SNAPPING = "snapping", e.SHADOW_ACCUMULATOR = "shadow accumulator", e.CLOUDS_GENERATOR = "cloud generator", e[e.TEST_PRIO = 1] = "TEST_PRIO";
}(f || (f = {}));
var A = 0,
    S = new Map([[f.RESOURCE_CONTROLLER, A], [f.SLIDE, A], [f.STREAM_DATA_LOADER, A], [f.ELEVATION_QUERY, A], [f.TERRAIN_SURFACE, 1], [f.SURFACE_GEOMETRY_UPDATES, 1], [f.GRAPHICS_CORE, 2], [f.I3S_CONTROLLER, 2], [f.POINT_CLOUD_LAYER, 2], [f.FEATURE_TILE_FETCHER, 2], [f.OVERLAY, 4], [f.STAGE, 4], [f.GRAPHICS_DECONFLICTOR, 4], [f.FILTER_VISIBILITY, 4], [f.SCALE_VISIBILITY, 4], [f.FRUSTUM_VISIBILITY, 4], [f.POINT_OF_INTEREST_FREQUENT, 6], [f.POINT_OF_INTEREST_INFREQUENT, 30], [f.LABELER, 8], [f.FEATURE_QUERY_ENGINE, 8], [f.FEATURE_TILE_TREE, 16], [f.FEATURE_TILE_TREE_ACTIVE, A], [f.ELEVATION_ALIGNMENT, 12], [f.TEXT_TEXTURE_ATLAS, 12], [f.CLOUDS_GENERATOR, 12], [f.TEXTURE_UNLOAD, 12], [f.LINE_OF_SIGHT_TOOL, 16], [f.LINE_OF_SIGHT_TOOL_INTERACTIVE, A], [f.SNAPPING, A], [f.SHADOW_ACCUMULATOR, 30]]);

function b(e) {
  return S.has(e) ? S.get(e) : "number" == typeof e ? e : 1;
}

var k = c(6.5),
    L = c(1),
    O = c(30),
    U = c(1e3 / 30),
    N = c(100),
    P = .9;
var F, y;
!function (r) {
  var h = /*#__PURE__*/function (_t) {
    _inherits(h, _t);

    var _super = _createSuper(h);

    function h(e) {
      var _this;

      _classCallCheck(this, h);

      _this = _super.call(this, e), _this.updating = !0, _this._microTaskQueued = !1, _this.performanceInfo = {
        total: new o("total"),
        tasks: new Map()
      }, _this._frameTaskTimes = new Map(), _this._budget = null, _this._state = 1, _this._tasks = new n(), _this._runQueue = new n(), _this._load = 0, _this._idleStateCallbacks = new n(), _this._idleUpdatesStartFired = !1, _this._maxReschedule = v, _this._forceTask = !1, _this._debug = !1, _this._debugHandle = E(p, "SCHEDULER_LOG_SLOW_TASKS", function (e) {
        return _this._debug = e;
      }), _this._budget = new d(e.nowFunc);

      for (var _i = 0, _Object$keys = Object.keys(f); _i < _Object$keys.length; _i++) {
        var _r = _Object$keys[_i];

        _this.performanceInfo.tasks.set(f[_r], new o(f[_r]));
      }

      var t;

      var s = _assertThisInitialized(_this);

      _this._test = {
        get state() {
          return i(t, s._state);
        },

        set state(e) {
          t = e;
        },

        FRAME_SAFETY_BUDGET: k,
        INTERACTING_BUDGET: U,
        IDLE_BUDGET: N,

        get budget() {
          return s._budget.budget;
        },

        usedBudget: 0,
        setBudget: function setBudget(e) {
          return s._budget = e;
        },
        updateTask: function updateTask(e) {
          return _this._updateTask(e);
        },
        getState: function getState(e) {
          return _this._getState(e);
        },
        getRuntime: function getRuntime(e) {
          return _this._getRuntime(e);
        },
        frameTaskTimes: _this._frameTaskTimes,
        resetRuntimes: function resetRuntimes() {
          return _this._resetRuntimes();
        },
        getRunning: function getRunning() {
          return _this._getRunning();
        }
      };
      return _this;
    }

    _createClass(h, [{
      key: "destroy",
      value: function destroy() {
        this._debugHandle && this._debugHandle.remove(), this._microTaskQueued = !1;
      }
    }, {
      key: "activate",
      value: function activate() {
        var _this2 = this;

        this._budget.done || this._microTaskQueued || (this._microTaskQueued = !0, queueMicrotask(function () {
          _this2._microTaskQueued && (_this2._microTaskQueued = !1, _this2._budget.done || (_this2._maxReschedule = v, _this2._schedule(), _this2.frame()));
        }));
      }
    }, {
      key: "registerTask",
      value: function registerTask(e, t) {
        var s = b(e),
            r = new _(this, e, t, s);
        return this._tasks.push(r), this.performanceInfo.tasks.has(e) || this.performanceInfo.tasks.set(e, new o(e)), r;
      }
    }, {
      key: "registerIdleStateCallbacks",
      value: function registerIdleStateCallbacks(e, t) {
        var _this3 = this;

        var s = {
          idleBegin: e,
          idleEnd: t
        };
        this._idleStateCallbacks.push(s), 2 === this.state && this._idleUpdatesStartFired && s.idleBegin();
        var r = this;
        return {
          remove: function remove() {
            return _this3._removeIdleStateCallbacks(s);
          },

          set idleBegin(e) {
            r._idleUpdatesStartFired && (s.idleEnd(), 2 === r._state && e()), s.idleBegin = e;
          },

          set idleEnd(e) {
            s.idleEnd = e;
          }

        };
      }
    }, {
      key: "now",
      get: function get() {
        return this.nowFunc();
      }
    }, {
      key: "load",
      get: function get() {
        return this._load;
      }
    }, {
      key: "state",
      get: function get() {
        return a(this._test.state) ? this._state : this._test.state;
      },
      set: function set(e) {
        this._state !== e && (this._state = e, 2 !== this.state && this._idleUpdatesStartFired && (this._idleUpdatesStartFired = !1, this._idleStateCallbacks.forAll(function (e) {
          return e.idleEnd();
        })));
      }
    }, {
      key: "updateBudget",
      value: function updateBudget(e) {
        this._test.usedBudget = 0;
        var t = k,
            s = e.frameDuration,
            r = L;

        switch (this.state) {
          case 2:
            t = c(0), s = c(Math.max(N, e.frameDuration)), r = O;
            break;

          case 1:
            s = c(Math.max(U, e.frameDuration));
        }

        return s = c(s - e.elapsedFrameTime - t), 2 !== this.state && s < L && !this._forceTask ? (this._forceTask = !0, !1) : (s = c(Math.max(s, r)), this._budget.reset(s, this.state), this._maxReschedule = v, this._updateLoad(), this._schedule());
      }
    }, {
      key: "frame",
      value: function frame() {
        switch (this._forceTask = !1, this._microTaskQueued = !1, this.state) {
          case 2:
            this._idleUpdatesStartFired || (this._idleUpdatesStartFired = !0, this._idleStateCallbacks.forAll(function (e) {
              return e.idleBegin();
            })), this._runIdle();
            break;

          case 1:
            this._runInteracting();

            break;

          default:
            this._runAnimating();

        }

        this._test.usedBudget = this._budget.elapsed;
      }
    }, {
      key: "stopFrame",
      value: function stopFrame() {
        this._budget.reset(c(0), this._state), this._budget.madeProgress();
      }
    }, {
      key: "_removeIdleStateCallbacks",
      value: function _removeIdleStateCallbacks(e) {
        this._idleUpdatesStartFired && e.idleEnd(), this._idleStateCallbacks.removeUnordered(e);
      }
    }, {
      key: "removeTask",
      value: function removeTask(e) {
        this._tasks.removeUnordered(e), this._runQueue.removeUnordered(e);
      }
    }, {
      key: "_updateTask",
      value: function _updateTask(e) {
        this._tasks.forAll(function (t) {
          t.name === e && t.setPriority(e);
        });
      }
    }, {
      key: "_getState",
      value: function _getState(e) {
        if (this._runQueue.some(function (t) {
          return t.name === e;
        })) return y.SCHEDULED;
        var t = y.IDLE;
        return this._tasks.forAll(function (s) {
          s.name === e && s.needsUpdate && (s.schedulePriority <= 1 ? t = y.READY : t !== y.READY && (t = y.WAITING));
        }), t;
      }
    }, {
      key: "_getRuntime",
      value: function _getRuntime(e) {
        var t = 0;
        return this._tasks.forAll(function (s) {
          s.name === e && (t += s.runtime);
        }), t;
      }
    }, {
      key: "_resetRuntimes",
      value: function _resetRuntimes() {
        this._tasks.forAll(function (e) {
          return e.runtime = 0;
        });
      }
    }, {
      key: "_getRunning",
      value: function _getRunning() {
        var e = new Map();
        if (this._tasks.forAll(function (t) {
          t.needsUpdate && e.set(t.name, (e.get(t.name) || 0) + 1);
        }), 0 === e.size) return null;
        var t = "";
        return e.forEach(function (e, s) {
          t += e > 1 ? " ".concat(e, "x ").concat(s) : " ".concat(s);
        }), t;
      }
    }, {
      key: "_runIdle",
      value: function _runIdle() {
        this._run();
      }
    }, {
      key: "_runInteracting",
      value: function _runInteracting() {
        this._run();
      }
    }, {
      key: "_runAnimating",
      value: function _runAnimating() {
        this._run();
      }
    }, {
      key: "_updateLoad",
      value: function _updateLoad() {
        var e = this._tasks.reduce(function (e, t) {
          return t.needsUpdate ? ++e : e;
        }, 0);

        this._load = this._load * P + e * (1 - P);
      }
    }, {
      key: "_schedule",
      value: function _schedule() {
        var _this4 = this;

        if (this._maxReschedule <= 0) return !1;

        var _loop = function _loop() {
          var e = !1,
              t = 0;
          if (_this4._tasks.forAll(function (s) {
            if (s.needsUpdate && 0 !== s.schedulePriority && s.basePriority !== A) if (e = !0, t = Math.max(t, s.basePriority), 1 === s.schedulePriority) s.schedulePriority = 0, _this4._runQueue.push(s);else --s.schedulePriority;
          }), !e) return {
            v: (_this4.updating = !1, !1)
          };
          _this4._maxReschedule === v && (_this4._maxReschedule = t), --_this4._maxReschedule;
        };

        for (this._runQueue.filterInPlace(function (e) {
          return !!e.needsUpdate || (e.schedulePriority = e.basePriority, !1);
        }), this._tasks.forAll(function (e) {
          e.basePriority === A && e.needsUpdate && !_this4._runQueue.some(function (t) {
            return t === e;
          }) && _this4._runQueue.unshift(e);
        }); 0 === this._runQueue.length;) {
          var _ret = _loop();

          if (typeof _ret === "object") return _ret.v;
        }

        return this.updating = !0, !0;
      }
    }, {
      key: "_run",
      value: function _run() {
        var e = this._budget.now();

        this._startFrameTaskTimes();

        do {
          for (; this._runQueue.length > 0;) {
            var _s = this._budget.now(),
                _r2 = this._runQueue.pop();

            this._budget.resetProgress();

            try {
              _r2.task.runTask(this._budget);
            } catch (t) {
              I.error("Exception in task \"".concat(_r2.name, "\""), t);
            }

            _r2.schedulePriority = _r2.basePriority;

            var _i2 = this._budget.now() - _s;

            if (_r2.runtime += _i2, this._frameTaskTimes.set(_r2.priority, this._frameTaskTimes.get(_r2.priority) + _i2), this._debug && this._budget.elapsed > 2 * this._budget.budget && console.log("Task", _r2.name, "used", this._budget.elapsed, "of max", this._budget.budget, "ms"), this._budget.remaining <= 0) return void this._recordFrameTaskTimes(this._budget.now() - e);
          }
        } while (this._schedule());

        this._recordFrameTaskTimes(this._budget.now() - e);
      }
    }, {
      key: "_startFrameTaskTimes",
      value: function _startFrameTaskTimes() {
        for (var _i3 = 0, _Object$keys2 = Object.keys(f); _i3 < _Object$keys2.length; _i3++) {
          var _e = _Object$keys2[_i3];

          this._frameTaskTimes.set(f[_e], 0);
        }
      }
    }, {
      key: "_recordFrameTaskTimes",
      value: function _recordFrameTaskTimes(e) {
        var _this5 = this;

        this._frameTaskTimes.forEach(function (e, t) {
          return _this5.performanceInfo.tasks.get(t).record(e);
        }), this.performanceInfo.total.record(e);
      }
    }, {
      key: "test",
      get: function get() {
        return this._test;
      }
    }]);

    return h;
  }(t);

  e([T()], h.prototype, "updating", void 0), e([T()], h.prototype, "nowFunc", void 0), h = e([m("esri.views.support.Scheduler")], h), r.Scheduler = h;

  var _ = /*#__PURE__*/function (_t2) {
    _inherits(_, _t2);

    var _super2 = _createSuper(_);

    function _(e, t, r, i) {
      var _this6;

      _classCallCheck(this, _);

      _this6 = _super2.call(this, {}), _this6._scheduler = e, _this6.name = t, _this6._basePriority = i, _this6.runtime = 0, _this6._queue = new g(), _this6._handles = new s(), _this6.schedulePriority = _this6._basePriority, _this6.task = u(r) ? r : _this6._queue, _this6._handles.add(l(function () {
        return _this6.task.running;
      }, function () {
        return e.activate();
      }));
      return _this6;
    }

    _createClass(_, [{
      key: "updating",
      get: function get() {
        return this._queue.running;
      }
    }, {
      key: "normalizeCtorArgs",
      value: function normalizeCtorArgs() {
        return {};
      }
    }, {
      key: "remove",
      value: function remove() {
        this.processQueue(C), this._scheduler.removeTask(this), this.schedule = D.schedule, this.reschedule = D.reschedule, this._handles.destroy();
      }
    }, {
      key: "basePriority",
      get: function get() {
        return this._basePriority;
      }
    }, {
      key: "setPriority",
      value: function setPriority(e) {
        this.name = e;
        var t = b(e);
        this._basePriority !== A && 0 === this.schedulePriority || (this.schedulePriority = t), this._basePriority = t;
      }
    }, {
      key: "priority",
      get: function get() {
        return this.name;
      },
      set: function set(e) {
        this.setPriority(e);
      }
    }, {
      key: "needsUpdate",
      get: function get() {
        return this.updating || this.task.running;
      }
    }, {
      key: "schedule",
      value: function schedule(e, t, s) {
        return this._queue.push(e, t, s);
      }
    }, {
      key: "reschedule",
      value: function reschedule(e, t, s) {
        return this._queue.unshift(e, t, s);
      }
    }, {
      key: "processQueue",
      value: function processQueue(e) {
        this._queue.runTask(e);
      }
    }]);

    return _;
  }(t);

  e([T({
    constructOnly: !0
  })], _.prototype, "task", void 0), e([T({
    readOnly: !0
  })], _.prototype, "updating", null), _ = e([m("esri.views.support.SchedulerTask")], _);

  var d = /*#__PURE__*/function () {
    function d(e) {
      _classCallCheck(this, d);

      this.now = e, this._begin = 0, this._budget = 0, this._state = 2, this._didWork = !1, this._enabled = !0;
    }

    _createClass(d, [{
      key: "run",
      value: function run(e) {
        return !this.done && (!0 === e() && (this._didWork = !0), !0);
      }
    }, {
      key: "done",
      get: function get() {
        return this._didWork && this.elapsed >= this._budget && this._enabled;
      }
    }, {
      key: "budget",
      get: function get() {
        return this._budget;
      }
    }, {
      key: "madeProgress",
      value: function madeProgress() {
        this._didWork = !0;
      }
    }, {
      key: "state",
      get: function get() {
        return this._state;
      }
    }, {
      key: "enabled",
      get: function get() {
        return this._enabled;
      },
      set: function set(e) {
        this._enabled = e;
      }
    }, {
      key: "reset",
      value: function reset(e, t) {
        this._begin = this.now(), this._budget = e, this._state = t, this._didWork = !1;
      }
    }, {
      key: "remaining",
      get: function get() {
        return Math.max(this._budget - this.elapsed, 0);
      }
    }, {
      key: "elapsed",
      get: function get() {
        return this.now() - this._begin;
      }
    }, {
      key: "resetProgress",
      value: function resetProgress() {
        this._didWork = !1;
      }
    }, {
      key: "hasProgressed",
      get: function get() {
        return this._didWork;
      }
    }]);

    return d;
  }();

  r.Budget = d;
}(F || (F = {})), function (e) {
  e.SCHEDULED = "s", e.READY = "r", e.WAITING = "w", e.IDLE = "i";
}(y || (y = {}));

var C = function () {
  var e = new F.Budget(function () {
    return performance.now();
  });
  return e.enabled = !1, e;
}();

var w = /*#__PURE__*/function () {
  function w() {
    _classCallCheck(this, w);
  }

  _createClass(w, [{
    key: "remove",
    value: function remove() {}
  }, {
    key: "processQueue",
    value: function processQueue() {}
  }, {
    key: "schedule",
    value: function schedule(e, t, s) {
      try {
        if (h(t)) {
          var _e2 = _();

          return s ? Promise.resolve(s(_e2)) : Promise.reject(_e2);
        }

        return d(e(C));
      } catch (r) {
        return Promise.reject(r);
      }
    }
  }, {
    key: "reschedule",
    value: function reschedule(e, t, s) {
      return this.schedule(e, t, s);
    }
  }]);

  return w;
}();

var D = new w(),
    v = Number.MAX_SAFE_INTEGER;
export { D as ImmediateTask, f as TaskPriority, y as TaskState, b as getTaskPriority, R as newScheduler, C as noBudget, S as taskPriorities };